import { inject, Injectable } from '@angular/core';
import { Apollo, gql, MutationResult } from 'apollo-angular';
import { GetQuery } from '../models/shared/enums/get-query';
import { Observable } from 'rxjs';
import { ApolloQueryResult } from '@apollo/client/core';
import { MutationQuery } from '../models/shared/enums/mutation-query.enum';
import { MutationResponse } from '../models/shared/types/mutation-response.type';
import { AppService } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class GraphQLService {
  readonly #apollo = inject(Apollo);
  readonly #appService = inject(AppService);

  getData<T>(query: GetQuery, variables?: any): Observable<ApolloQueryResult<T>> {
    const companyId = this.#appService.companyId;
    if (!variables) {
      variables = { companyId };
    } else if (!variables.companyId) {
      variables.companyId = companyId;
    }

    return this.#apollo.watchQuery<T>({
      query: gql`${query}`, 
      variables, 
      fetchPolicy: 'no-cache'
    }).valueChanges;
  }

  postData(mutation: MutationQuery, variables?: any): Observable<MutationResult<MutationResponse>> {
    const companyId = this.#appService.companyId;
    if (!variables) {
      variables = { companyId };
    } else if (!variables.companyId) {
      variables.companyId = companyId;
    }
    
    return this.#apollo.mutate({
      mutation: gql`${mutation}`,
      variables,
      fetchPolicy: 'no-cache',
    });
  }
}
